import { useQuery } from '@tanstack/react-query';
import { turmaService } from '../../shared/services';
import { Users, Calendar, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';

export function CohortsPage() {
  const { data: turmas, isLoading } = useQuery({
    queryKey: ['turmas'],
    queryFn: turmaService.getMinhasTurmas,
  });

  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Minhas Turmas</h1>
          <p className="text-gray-600 mt-2">Acompanhe suas turmas e conteúdos</p>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {turmas?.map((turma) => (
              <Link
                key={turma.id}
                to={`/turmas/${turma.id}`}
                className="card hover:shadow-lg transition-shadow"
              >
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
                    <Users className="text-primary-600" size={20} />
                  </div>
                  {turma.ativa && (
                    <span className="px-2 py-1 bg-green-100 text-green-700 text-xs font-medium rounded">
                      Ativa
                    </span>
                  )}
                </div>

                <h3 className="text-lg font-bold text-gray-900 mb-2">{turma.titulo}</h3>
                
                {turma.descricao && (
                  <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                    {turma.descricao}
                  </p>
                )}

                <div className="space-y-2 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <Calendar size={16} />
                    <span>
                      Início: {new Date(turma.dataInicio).toLocaleDateString('pt-BR')}
                    </span>
                  </div>
                  {turma.dataFim && (
                    <div className="flex items-center gap-2">
                      <Calendar size={16} />
                      <span>
                        Fim: {new Date(turma.dataFim).toLocaleDateString('pt-BR')}
                      </span>
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <BookOpen size={16} />
                    <span>{turma.conteudos?.length || 0} conteúdos</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
